import profile from "../../asserts/images/profile.svg";
import arro from "../../asserts/images/arrow_drop_down.svg";
import logo from "../../asserts/images/logos/Colour_Trans_Horizontal.svg";
import logomobile from "../../asserts/images/logos/Pagirndhunn-logo-mobile.svg";

import "bootstrap/dist/css/bootstrap.min.css";
import "./header.scss";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useState } from "react";
import Login from "../Login/Signup/login";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showLogin, setShowLogin] = useState(false);
  const [user, setUser] = useState<any>(null);

  useState(() => {
    const userStr = localStorage.getItem("user");
    if (userStr) setUser(JSON.parse(userStr));
  });

  const checkUserStatus = () => {
    const userStr = localStorage.getItem("user");
    if (userStr) setUser(JSON.parse(userStr));
    else setUser(null);
    setShowLogin(false);
  };

  const login = () => {
    setShowLogin(true);
  };

  const donatepage = () => {
    navigate("/donatenow");
  };


  return (
    <div>
      {showLogin && <Login onClose={checkUserStatus} />}
      <nav className="navbar navbar-expand-lg navbar-light bg-light top px-0">
        <div className="container-fluid">
          <a className="navbar-brand logo" href="#">
            <img src={logo} alt="Company logo" className="d-none d-lg-block" />
            <img src={logomobile} alt="Company logo" className="d-block d-lg-none" />
          </a>
          <div className="d-flex align-items-center order-lg-last">
            <button className="donatebutton donatebutton-mobile btn btn-primary d-block d-lg-none" onClick={donatepage}>Donate Now</button>
            <button
              className="navbar-toggler me-3 ms-3"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            {user && (
              <div
                className="d-flex d-lg-none align-items-center justify-content-center ms-2 me-2 cursor-pointer"
                style={{
                  cursor: 'pointer',
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  background: 'conic-gradient(#D1D1D1 0deg 90deg, #F6A841 90deg 360deg)'
                }}
                onClick={() => navigate('/dashboard')}
              >
                <div style={{
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  backgroundColor: '#2b333e',
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  fontSize: '0.9rem'
                }}>
                  {user.fullName.charAt(0).toUpperCase()}
                </div>
              </div>
            )}
          </div>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 menu text-center">
              <li className={location.pathname.includes('/home') ? "nav-item active" : "nav-item"} >
                <Link className="nav-link" aria-current="page" to={"/home"}>Home</Link>
              </li>
              <li className={location.pathname.includes('/aboutus') ? "nav-item active" : "nav-item"}>
                <Link className="nav-link" aria-current="page" to={"/aboutus"}>About us</Link>
              </li>
              <li className={location.pathname.includes('/gallery') ? "nav-item active" : "nav-item"}>
                <Link className="nav-link" aria-current="page" to={"/gallery"}>Gallery</Link>
              </li>
              <li className={location.pathname.includes('/contactus') ? "nav-item active" : "nav-item"}>
                <Link className="nav-link" aria-current="page" to={"/contactus"}>Contact Us</Link>
              </li>
              {!user && (
                <li className="nav-item d-lg-none mt-3">
                  <button className="littlebutton btn btn-primary" onClick={login}>Login/Signup</button>
                </li>
              )}
            </ul>

            <div className="d-flex align-items-center justify-content-center justify-content-lg-end gap-3">
              {user ? (
                <div
                  className="d-none d-lg-flex align-items-center gap-2 cursor-pointer"
                  onClick={() => navigate('/dashboard')}
                  style={{
                    cursor: 'pointer',
                  }}
                >
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{

                      width: '42px',
                      height: '42px',
                      borderRadius: '50%',
                      background: 'conic-gradient(#D1D1D1 0deg 90deg, #F6A841 90deg 360deg)'
                    }}
                  >
                    <div style={{
                      width: '34px',
                      height: '34px',
                      borderRadius: '50%',
                      backgroundColor: '#2b333e',
                      color: '#fff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 'bold',
                      fontSize: '1rem'
                    }}>
                      {user.fullName.charAt(0).toUpperCase()}
                    </div>
                  </div>
                  <span style={{ fontWeight: 600, color: '#333' }}>
                    {user.fullName.split(' ')[0]}
                  </span>
                  <img src={arro} alt="Arrow" />
                </div>
              ) : (
                <button className="littlebutton btn btn-primary d-none d-lg-block" onClick={login}>Login/Signup</button>
              )}
              <button className="donatebutton btn btn-primary d-none d-lg-block" onClick={donatepage}>Donate Now</button>
            </div>
          </div>
        </div>
      </nav >
    </div >
  );
}

export default Header;
